import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import debounce from '../../utils/debounce.js';
import { Button as Button$2, Icon, Text } from './Button.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["children", "name", "onClick", "href", "disabled", "loading", "size", "variant", "iconBefore", "iconAfter", "fullWidthMobile", "ariaLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Button = function Button(_ref) {
  var children = _ref.children,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? null : _ref$href,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'secondary' : _ref$variant,
    _ref$iconBefore = _ref.iconBefore,
    iconBefore = _ref$iconBefore === void 0 ? null : _ref$iconBefore,
    _ref$iconAfter = _ref.iconAfter,
    iconAfter = _ref$iconAfter === void 0 ? null : _ref$iconAfter,
    _ref$fullWidthMobile = _ref.fullWidthMobile,
    fullWidthMobile = _ref$fullWidthMobile === void 0 ? false : _ref$fullWidthMobile,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? null : _ref$ariaLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var missingOnClickAndUrl = typeof onClick !== 'function' && !href && !loading && !disabled;
  if (!children) {
    return false;
  }
  var elementName = name || children;
  var renderType = href ? 'a' : 'button';
  if (missingOnClickAndUrl) {
    renderType = 'div';
  }
  return /*#__PURE__*/jsxs(Button$2, _objectSpread(_objectSpread({
    // @ts-ignore
    name: elementName,
    type: renderType === 'button' ? 'button' : null,
    as: renderType,
    onClick: disabled || !onClick ? undefined : debounce(onClick, 400, {
      leading: true,
      trailing: false
    }),
    href: href || null,
    "aria-busy": loading,
    "aria-disabled": disabled,
    "aria-label": ariaLabel,
    $loading: loading,
    $disabled: disabled,
    $size: size,
    $variant: variant,
    $fullWidthMobile: fullWidthMobile
  }, rest), {}, {
    children: [/*#__PURE__*/React.isValidElement(iconBefore) && /*#__PURE__*/jsx(Icon, {
      children: /*#__PURE__*/React.cloneElement(iconBefore, {
        size: 'xxs'
      })
    }), /*#__PURE__*/jsx(Text, {
      $loading: loading,
      children: children
    }), /*#__PURE__*/React.isValidElement(iconAfter) && /*#__PURE__*/jsx(Icon, {
      $right: true,
      children: /*#__PURE__*/React.cloneElement(iconAfter, {
        size: 'xxs'
      })
    })]
  }));
};
var Button$1 = Button;

export { Button$1 as default };
//# sourceMappingURL=Button.js.map
